// internal
import { axios, def, storage, handleError, handleResponse } from './internal';
import { coolDownBegin, coolDownEnd } from '../request-control/cooldown';

function Report(type, targetId, reason, onSuccess, setData) {
    const key = `report:${type}:${targetId}`;
    if (!coolDownBegin(key)) return; // the previous request is still running or just finished (double click)
    setData?.((prev) => ({ ...prev, loading: true }));
    axios
        .post('/api/reports', {
            type,
            targetId,
            reason,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    storage.transience.setState('internal.success', 'Your report has been submitted.');
                    if (onSuccess) onSuccess();
                    break;
                case def.ErrorCode.REPORT_ALREADY_PENDING:
                    storage.transience.setState('internal.error', 'your report is already pending review');
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        })
        .finally(() => {
            coolDownEnd(key);
            setData?.((prev) => ({ ...prev, loading: false }));
        });
}

export { Report };
